import PropTypes from 'prop-types';

import { StyledTable, StyledTableContainer } from '../../BillingHistory.styles';
import InvoiceRow from '../InvoiceRow';

function ChargesTable({ data }) {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <StyledTableContainer>
      <StyledTable>
        <thead>
          <tr>
            <th>Date</th>
            <th>Payment Method</th>
            <th>Amount</th>
            <th aria-label="Actions" />
          </tr>
        </thead>
        <tbody>
          {data.map((invoice) => (
            <InvoiceRow key={invoice.invoiceId} invoice={invoice} />
          ))}
        </tbody>
      </StyledTable>
    </StyledTableContainer>
  );
}

ChargesTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      invoiceId: PropTypes.string.isRequired,
      invoiceUrl: PropTypes.string,
      chargeDate: PropTypes.string.isRequired,
      amount: PropTypes.string.isRequired,
      paymentMethod: PropTypes.shape({
        brand: PropTypes.string.isRequired,
        last4: PropTypes.string
      }).isRequired
    })
  )
};

export default ChargesTable;
